import React from 'react';
import { Link } from 'react-router-dom';
import LegalPage from '../../components/LegalPage';

const CookieRichtlinien = () => (
  <LegalPage title="Cookie-Richtlinien">
    <p><strong>Stand:</strong> {new Date().getFullYear()}</p>

    <h2>Was sind Cookies &amp; lokale Speicher?</h2>
    <p>
      Neben klassischen Cookies verwenden wir im Tippspiel auch den lokalen Speicher deines Browsers
      (localStorage), z. B. für Login und Cookie-Einstellungen.
    </p>

    <h2>Notwendige Speicher (immer aktiv)</h2>
    <ul>
      <li><strong>Login-Token:</strong> hält deine Anmeldung aufrecht</li>
      <li><strong>Cookie-Einstellungen:</strong> speichert deine Auswahl zu optionalen Kategorien</li>
    </ul>

    <h2>Optionale Kategorien (nur mit Einwilligung)</h2>
    <ul>
      <li><strong>Präferenzen:</strong> merken sich optionale UI-Einstellungen</li>
      <li><strong>Statistiken:</strong> anonymisierte Nutzungsauswertung (falls aktiviert)</li>
    </ul>

    <h2>Verwaltung</h2>
    <p>
      Du kannst deine Auswahl jederzeit über „Cookie-Einstellungen“ im Footer ändern.
      Notwendige Speicher sind für den Betrieb des Tippspiels erforderlich und können nicht abgewählt werden.
    </p>

    <h2>Weitere Informationen</h2>
    <p>
      Allgemeine Informationen zum Datenschutz:{' '}
      <Link to="/datenschutz" className="text-primary-light hover:underline">Datenschutzerklärung</Link>
      {' · '}
      <a href="https://tivoli12.at/cookie-richtlinien" target="_blank" rel="noopener noreferrer">
        Cookie-Richtlinien tivoli12.at
      </a>
    </p>
  </LegalPage>
);

export default CookieRichtlinien;
